/* Spark E-Bikes theme script */
(function () {
  'use strict';
  var S = window.Spark || {};
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var reduceMotion = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- money ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = parseInt(cents, 10) || 0;
    format = format || S.moneyFormat || '${{amount}}';
    function delim(n, prec, thou, dec) {
      thou = thou === undefined ? ',' : thou; dec = dec === undefined ? '.' : dec;
      var num = (n / 100).toFixed(prec);
      var parts = num.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thou);
      return whole + (parts[1] ? dec + parts[1] : '');
    }
    var m = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var val = '';
    switch (m ? m[1] : 'amount') {
      case 'amount_no_decimals': val = delim(cents, 0); break;
      case 'amount_with_comma_separator': val = delim(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': val = delim(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': val = delim(cents, 2, "'", '.'); break;
      default: val = delim(cents, 2);
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, val).replace(/<[^>]+>/g, '');
  }
  S.formatMoney = formatMoney;
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  /* ---------- toast ---------- */
  var tt;
  function toast(t) {
    var el = $('#toast'); if (!el) return;
    el.textContent = t; el.hidden = false; el.classList.remove('out'); void el.offsetWidth; el.classList.add('in');
    clearTimeout(tt);
    tt = setTimeout(function () { el.classList.add('out'); setTimeout(function () { el.hidden = true; el.classList.remove('in', 'out'); }, 220); }, 2400);
  }

  /* ---------- mobile menu ---------- */
  var MENU = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M4 7h16M4 12h16M4 17h16"/></svg>';
  var CLOSE = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg>';
  function setMenu(open) {
    var m = $('#mnav'), b = $('#menuBtn'); if (!m || !b) return;
    m.classList.toggle('open', open); m.inert = !open;
    b.setAttribute('aria-expanded', open); b.innerHTML = open ? CLOSE : MENU; b.setAttribute('aria-label', open ? 'Close menu' : 'Menu');
  }
  var mb = $('#menuBtn');
  if (mb) mb.addEventListener('click', function () { setMenu(!$('#mnav').classList.contains('open')); });

  /* ---------- cart drawer ---------- */
  var drawer = $('#drawer'), scrim = $('#scrim'), lastFocus = null, cartState = null;
  function openCart() {
    if (!drawer) { window.location = S.routes.cartPage; return; }
    lastFocus = document.activeElement;
    drawer.inert = false; drawer.classList.add('open'); scrim.classList.add('open'); document.body.style.overflow = 'hidden';
    setTimeout(function () { var c = $('#drClose'); if (c) c.focus(); }, 60);
  }
  function closeCart() {
    if (!drawer) return;
    drawer.classList.remove('open'); drawer.inert = true; scrim.classList.remove('open'); document.body.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  function setCount(n) {
    var b = $('#cartCount'); if (b) { b.hidden = !n; b.textContent = n; }
    var cb = $('#cartBtn'); if (cb) cb.setAttribute('aria-label', 'Cart, ' + n + ' items');
  }
  function fetchCart() {
    return fetch(S.routes.cart, { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) { cartState = c; renderCart(c); return c; });
  }
  function renderCart(c) {
    setCount(c.item_count);
    var body = $('#drBody'), foot = $('#drFoot'); if (!body) return;
    if (!c.items.length) {
      body.innerHTML = '<div class="dr-empty"><b>Your cart is empty</b>Start with the Kit Finder if you\'re not sure which kit suits your bike.<div style="margin-top:1rem"><a class="btn btn-buy" href="/pages/kit-finder">Find my kit</a></div></div>';
      foot.innerHTML = ''; return;
    }
    var html = c.items.map(function (it, i) {
      var img = it.image ? '<img src="' + esc(it.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x160$1$2')) + '" alt="" loading="lazy">' : '';
      var variant = it.product_has_only_default_variant ? '' : '<span>' + esc(it.variant_title || '') + '</span>';
      return '<div class="line"><a class="mini" href="' + esc(it.url) + '">' + img + '</a><div><b>' + esc(it.product_title) + '</b>' + variant +
        '<div class="qty"><button type="button" data-line="' + (i + 1) + '" data-q="' + (it.quantity - 1) + '" aria-label="Decrease quantity">−</button><output>' + it.quantity + '</output><button type="button" data-line="' + (i + 1) + '" data-q="' + (it.quantity + 1) + '" aria-label="Increase quantity">+</button></div></div>' +
        '<div class="lp"><span class="num">' + formatMoney(it.final_line_price) + '</span><button class="rm" type="button" data-line="' + (i + 1) + '" data-q="0">Remove</button></div></div>';
    }).join('');
    var hasKit = c.items.some(function (it) { return /motor kit/i.test(it.product_title); });
    if (S.upsell && hasKit && !c.items.some(function (it) { return it.variant_id === S.upsell.variantId || it.url.indexOf(S.upsell.url) === 0; })) {
      html += '<div class="upsell"><div><b>Upgrade the throttle?</b>' + esc(S.upsell.title) + ', ' + formatMoney(S.upsell.price) + (S.upsell.compare > S.upsell.price ? ' (was ' + formatMoney(S.upsell.compare) + ')' : '') + '</div><button class="btn btn-dark" type="button" data-upsell style="padding:.55em .9em">Add</button></div>';
    }
    body.innerHTML = html;
    foot.innerHTML = '<div class="total"><span>Subtotal</span><b class="num">' + formatMoney(c.total_price) + '</b></div>' +
      (S.shipNote ? '<small>' + esc(S.shipNote) + '</small>' : '') +
      '<a class="btn btn-buy btn-block" href="' + esc(S.routes.checkout) + '">Check out</a><small class="dr-err" id="drErr" aria-live="polite"></small>';
  }
  function changeLine(line, qty) {
    drawer.classList.add('busy');
    return fetch(S.routes.cartChange, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ line: line, quantity: qty }) })
      .then(function (r) { return r.json(); }).then(function (c) { if (c.items) { cartState = c; renderCart(c); } else { var e = $('#drErr'); if (e) e.textContent = c.description || 'That quantity isn\'t available.'; } })
      .catch(function () { var e = $('#drErr'); if (e) e.textContent = 'Couldn\'t update the cart. Check your connection and try again.'; })
      .finally(function () { drawer.classList.remove('busy'); });
  }
  function addItems(items) {
    return fetch(S.routes.cartAdd, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () { return fetchCart(); })
      .then(function () { toast(items.length > 1 ? 'Kit and battery added to cart' : 'Added to cart'); openCart(); });
  }
  S.addItems = addItems;
  if (drawer) {
    $('#drBody').addEventListener('click', function (e) {
      var q = e.target.closest('[data-line]');
      if (q) changeLine(parseInt(q.dataset.line, 10), parseInt(q.dataset.q, 10));
      if (e.target.closest('[data-upsell]') && S.upsell) addItems([{ id: S.upsell.variantId, quantity: 1 }]).catch(function () {});
    });
    $('#drClose').addEventListener('click', closeCart);
    scrim.addEventListener('click', closeCart);
    var cartBtn = $('#cartBtn');
    if (cartBtn) cartBtn.addEventListener('click', function (e) { e.preventDefault(); fetchCart().then(openCart).catch(function () { window.location = S.routes.cartPage; }); });
  }
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (drawer && drawer.classList.contains('open')) closeCart();
    var m = $('#mnav'); if (m && m.classList.contains('open')) setMenu(false);
  });

  /* ---------- hero video ---------- */
  var reel = $('#reel') || $('.reel video'), reelBtn = $('#reelBtn');
  if (reel && reelBtn) {
    var P1 = '<svg viewBox="0 0 16 16" fill="currentColor"><rect x="3" y="2" width="3.5" height="12"/><rect x="9.5" y="2" width="3.5" height="12"/></svg>';
    var P2 = '<svg viewBox="0 0 16 16" fill="currentColor"><path d="M4 2l10 6-10 6z"/></svg>';
    var sync = function () { reelBtn.innerHTML = reel.paused ? P2 : P1; reelBtn.setAttribute('aria-label', reel.paused ? 'Play video' : 'Pause video'); };
    reel.muted = true; reel.setAttribute('playsinline', '');
    if (reduceMotion) { reel.removeAttribute('autoplay'); reel.pause(); }
    reelBtn.addEventListener('click', function () { if (reel.paused) reel.play(); else reel.pause(); });
    reel.addEventListener('play', sync); reel.addEventListener('pause', sync); sync();
  }

  /* ---------- help wizard ---------- */
  $$('[data-wiz]').forEach(function (w) {
    w.addEventListener('click', function (e) {
      var c = e.target.closest('[data-help]'); if (!c) return;
      $$('[data-help]', w).forEach(function (x) { x.setAttribute('aria-pressed', x === c); });
      $$('[data-help-ans]', w).forEach(function (a) {
        var on = a.dataset.helpAns === c.dataset.help; a.hidden = !on;
        if (on) { a.classList.remove('swap'); void a.offsetWidth; a.classList.add('swap'); }
      });
    });
  });
  (function prefillTopic() {
    var sel = $('#cTopic'); if (!sel) return;
    var m = location.search.match(/[?&]topic=([^&]+)/); if (!m) return;
    var t = decodeURIComponent(m[1].replace(/\+/g, ' '));
    for (var i = 0; i < sel.options.length; i++) if (sel.options[i].text === t) sel.selectedIndex = i;
  })();
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-topic]'); if (!t) return;
    var sel = $('#cTopic'); if (!sel) return;
    e.preventDefault();
    for (var i = 0; i < sel.options.length; i++) if (sel.options[i].text === t.dataset.topic) sel.selectedIndex = i;
    var c = $('#contact'); if (c) c.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth' });
    var n = $('#cName'); if (n) n.focus({ preventScroll: true });
  });

  /* ---------- product page ---------- */
  var pdp = $('[data-pdp]');
  if (pdp) initProduct(pdp);
  function initProduct(root) {
    var data; try { data = JSON.parse($('#ProductJson').textContent); } catch (e) { return; }
    var form = $('#ProductForm'), idInput = $('#VariantId'), addBtn = $('#AddBtn'), msg = $('#formMsg');
    var groups = $$('[data-opt-index]', root);
    var batt = { id: null, price: 0 };
    var firstRender = true;
    var current = data.variants.find(function (v) { return String(v.id) === idInput.value; }) || data.variants[0];

    function selected() {
      var opts = [];
      groups.forEach(function (g) {
        var on = $('[aria-checked="true"]', g);
        opts[parseInt(g.dataset.optIndex, 10)] = on ? on.dataset.value : null;
      });
      return opts;
    }
    function findVariant(opts) {
      return data.variants.find(function (v) { return v.options.every(function (o, i) { return opts[i] == null || o === opts[i]; }); });
    }
    function updateAvailability() {
      var opts = selected();
      groups.forEach(function (g) {
        var gi = parseInt(g.dataset.optIndex, 10);
        $$('.pill', g).forEach(function (p) {
          var test = opts.slice(); test[gi] = p.dataset.value;
          var v = data.variants.find(function (x) { return x.options.every(function (o, i) { return test[i] == null || o === test[i]; }); });
          p.dataset.unavailable = !(v && v.available);
        });
      });
    }
    function render() {
      var v = current;
      var price = $('[data-price]', root), cmp = $('[data-compare]', root), save = $('[data-save]', root);
      if (!v) {
        addBtn.disabled = true; addBtn.textContent = 'Unavailable'; return;
      }
      idInput.value = v.id;
      price.textContent = formatMoney(v.price);
      var onSale = v.compare > v.price;
      cmp.hidden = !onSale; save.hidden = !onSale;
      if (onSale) { cmp.textContent = formatMoney(v.compare); save.textContent = 'Save ' + formatMoney(v.compare - v.price); }
      var withBatt = data.isKit && batt.id;
      var tr = $('#totalRow');
      if (tr) { tr.hidden = !withBatt; if (withBatt) $('#totalVal').textContent = formatMoney(v.price + batt.price); }
      addBtn.disabled = !v.available;
      addBtn.textContent = !v.available ? 'Sold out' : (withBatt ? 'Add kit and battery to cart' : 'Add to cart');
      var sb = $('#sbPrice'); if (sb) sb.textContent = formatMoney(v.price + (withBatt ? batt.price : 0)) + (withBatt ? ' with battery' : '');
      var sbAdd = $('#sbAdd'); if (sbAdd) sbAdd.disabled = !v.available;
      groups.forEach(function (g) { var lbl = $('[data-opt-label]', g); var on = $('.swatch[aria-checked="true"]', g); if (lbl && on) lbl.textContent = on.dataset.value; });
      var nn = $('#needNote'); if (nn) nn.hidden = /40ah/i.test(v.title);
      if (v.media && !firstRender) showMedia(String(v.media));
      firstRender = false;
      try { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u.toString()); } catch (e) {}
    }
    root.addEventListener('click', function (e) {
      var p = e.target.closest('.pill[data-value]');
      if (p) {
        var g = p.closest('[data-opt-index]');
        $$('.pill', g).forEach(function (x) { x.setAttribute('aria-checked', x === p); });
        current = findVariant(selected());
        if (g.closest('#advBox')) { var av = $('#advVal'); if (av) av.textContent = p.dataset.value; }
        updateAvailability(); render(); return;
      }
      var b = e.target.closest('.bopt');
      if (b) {
        $$('.bopt', root).forEach(function (x) { x.setAttribute('aria-checked', x === b); });
        batt = { id: b.dataset.variantId ? parseInt(b.dataset.variantId, 10) : null, price: parseInt(b.dataset.price, 10) || 0 };
        render(); return;
      }
      var f = e.target.closest('[data-fit]');
      if (f) { fitCheck(f); return; }
      var t = e.target.closest('[data-media-id]');
      if (t) { showMedia(t.dataset.mediaId); return; }
    });
    var adv = $('#advBtn');
    if (adv) adv.addEventListener('click', function () { var b = $('#advBox'); b.hidden = false; b.classList.add('swap'); $('#advLine').hidden = true; });
    var more = $('#bMoreBtn');
    if (more) more.addEventListener('click', function () {
      var m = $('#bMore'), open = !m.classList.contains('open');
      m.classList.toggle('open', open); more.setAttribute('aria-expanded', open); more.textContent = open ? 'Show fewer options' : more.dataset.label;
    });
    var rec = $('.bopt[aria-checked="true"]', root);
    if (rec) batt = { id: parseInt(rec.dataset.variantId, 10) || null, price: parseInt(rec.dataset.price, 10) || 0 };

    function showMedia(id) {
      var thumb = $('[data-media-id="' + id + '"]', root), main = $('#gMain'); if (!thumb || !main) return;
      $$('[data-media-id]', root).forEach(function (x) { x.setAttribute('aria-current', x === thumb); });
      var tpl = $('template[data-media-tpl="' + id + '"]', root);
      if (tpl) main.innerHTML = tpl.innerHTML;
      else main.innerHTML = '<img src="' + esc(thumb.dataset.src) + '" alt="' + esc(data.title) + '">';
      main.classList.remove('swap'); void main.offsetWidth; main.classList.add('swap');
    }
    function fitCheck(btn) {
      var box = btn.closest('.fitbox'), res = $('#fitRes');
      $$('[data-fit]', box).forEach(function (x) { x.setAttribute('aria-checked', x === btn); });
      var drops = box.dataset.drops.split(','), v = btn.dataset.fit;
      var IC = { ok: '<svg viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="2.4"><path d="M4 10.5l4 4 8-9"/></svg>', no: '<svg viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="2.4"><path d="M5 5l10 10M15 5 5 15"/></svg>', maybe: '<svg viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="2"><circle cx="10" cy="10" r="8"/><path d="M10 9v5M10 6v.5"/></svg>' };
      if (v === 'unsure') { res.className = 'fit-res maybe'; res.innerHTML = IC.maybe + '<span>Measure between the inside faces of the rear dropouts, or <a href="/pages/contact?topic=Fitment%20check#contact">send us a photo</a> and we\'ll tell you.</span>'; return; }
      if (drops.indexOf(v) > -1) { res.className = 'fit-res ok'; res.innerHTML = IC.ok + '<span>' + v + ' mm fits this kit.</span>'; return; }
      var all = (box.dataset.alts || '').split('@@').filter(Boolean).map(function (a, i) { var p = a.split('~'); return { i: i, h: p[0], url: p[1], short: p[2], drops: (p[3] || '').split('/') }; });
      var me = all.filter(function (k) { return location.pathname.indexOf('/products/' + k.h) > -1; })[0];
      var meI = me ? me.i : 0, best = null;
      all.forEach(function (k) { if (k !== me && k.drops.indexOf(v) > -1 && (!best || Math.abs(k.i - meI) < Math.abs(best.i - meI))) best = k; });
      res.className = 'fit-res no';
      res.innerHTML = IC.no + '<span>This kit needs ' + drops.join(' or ') + ' mm.' + (best ? ' The <a href="' + esc(best.url) + '">' + esc(best.short) + ' kit</a> fits ' + v + ' mm.' : '') + '</span>';
    }
    function submit(e) {
      if (e) e.preventDefault();
      if (!current || !current.available) return;
      msg.textContent = '';
      var items = [{ id: current.id, quantity: 1 }];
      if (data.isKit && batt.id) items.push({ id: batt.id, quantity: 1 });
      addBtn.disabled = true;
      addItems(items).catch(function (err) {
        msg.textContent = (err && (err.description || err.message)) || 'Couldn\'t add to cart. Try again.';
      }).finally(function () { addBtn.disabled = !current.available; });
    }
    form.addEventListener('submit', submit);
    var sbAdd = $('#sbAdd'); if (sbAdd) sbAdd.addEventListener('click', submit);
    if ('IntersectionObserver' in window && $('#stickyBuy')) {
      new IntersectionObserver(function (en) {
        var s = $('#stickyBuy'), e0 = en[0];
        s.classList.toggle('show', !e0.isIntersecting && e0.boundingClientRect.top < 0);
        s.setAttribute('aria-hidden', e0.isIntersecting);
      }).observe(addBtn);
    }
    updateAvailability(); render();
  }

  /* ---------- kits ladder ---------- */
  var ladder = $('[data-ladder]');
  if (ladder) {
    var K = []; try { K = JSON.parse($('#LadderJson').textContent); } catch (e) {}
    var track = $('#track'), ticks = $('#ticks'), seg = $('#seg'), MAX = 10.5;
    var pct = function (k) { return (k / MAX * 100) + '%'; };
    for (var k = 0; k <= 10; k++) { var t = document.createElement('span'); t.style.left = pct(k); t.textContent = k ? k : '0 kW'; ticks.appendChild(t); }
    var sel = function (i, focus) {
      var p = K[i]; if (!p) return;
      $$('.stop', track).forEach(function (b, j) { b.setAttribute('aria-pressed', j === i); });
      $$('button', seg).forEach(function (b, j) { b.setAttribute('aria-pressed', j === i); });
      $('#lW').innerHTML = esc(p.short.replace(' W', '')) + '<small>W</small>';
      $('#lTxt').innerHTML = '<b>' + esc(p.volts) + ', ' + esc(p.amps) + ' controller, up to ' + esc(p.speed) + '.</b> ' + esc(p.sub) + ' From ' + esc(p.price) + '.';
      var go = $('#lGo'); go.href = p.url; go.textContent = 'View the ' + p.short + ' kit';
      if (focus) $$('.stop', track)[i].focus();
    };
    K.forEach(function (p, i) {
      var b = document.createElement('button'); b.type = 'button'; b.className = 'stop'; b.dataset.kw = p.kw; b.style.left = pct(p.kw);
      b.innerHTML = '<span>' + p.kw + ' kW</span><i></i>'; b.setAttribute('aria-label', p.short + ' kit');
      b.addEventListener('click', function () { sel(i); });
      b.addEventListener('keydown', function (e) { if (e.key === 'ArrowRight' && i < K.length - 1) { sel(i + 1, true); e.preventDefault(); } if (e.key === 'ArrowLeft' && i > 0) { sel(i - 1, true); e.preventDefault(); } });
      track.appendChild(b);
      var s = document.createElement('button'); s.type = 'button'; s.textContent = p.kw + 'k'; s.setAttribute('aria-label', p.short + ' kit'); s.addEventListener('click', function () { sel(i); }); seg.appendChild(s);
    });
    sel(Math.min(3, K.length - 1));
  }

  /* ---------- battery filter ---------- */
  var bf = $$('[data-bf]');
  if (bf.length) {
    document.addEventListener('click', function (e) {
      var f = e.target.closest('[data-bf]'); if (!f) return;
      bf.forEach(function (x) { x.setAttribute('aria-pressed', x === f); });
      $$('#cgrid .card').forEach(function (c) {
        var v = parseInt(c.dataset.volts, 10) || 0, show = true;
        if (f.dataset.bf === 'low') show = v > 0 && v < 72;
        if (f.dataset.bf === '72') show = v === 72;
        c.hidden = !show;
      });
    });
  }

  /* ---------- kit finder ---------- */
  var finder = $('[data-finder]');
  if (finder) initFinder(finder);
  function initFinder(root) {
    var D; try { D = JSON.parse($('#FinderJson').textContent); } catch (e) { return; }
    var KITS = D.kits, st = { step: 0 };
    var ARROW = '<svg viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="2.2"><path d="M7 4l6 6-6 6"/></svg>';
    var CHECK = '<svg viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="2.4"><path d="M4 10.5l4 4 8-9"/></svg>';
    var Q = [
      { k: 'use', t: 'What do you want it to do?', d: 'Pick the closest. You can change it later.', o: [['cheap', 'Get around for less', 'Trails and getting about, up to about 55 km/h'], ['trail', 'Trail fun with some speed', 'Up to about 65 km/h'], ['fast', 'Proper fast', '85 to 95 km/h territory'], ['max', 'As much power as possible', '10 kW, 100 km/h plus']] },
      { k: 'drop', t: 'How wide are your rear dropouts?', d: 'Measure between the inside faces of the slots the rear axle sits in.', measure: true, o: [['135', '135 mm', 'Most standard mountain bikes'], ['150', '150 mm', 'Downhill and some e-MTB frames'], ['170', '170 mm', 'Wide or fat-bike style frames'], ['unsure', 'Not sure', "We'll pick a safe option and flag it"]] },
      { k: 'wheel', t: 'What size is your rear wheel?', d: "It's printed on the side of the tyre, like 27.5 x 2.35.", o: [['26', '26 inch', ''], ['27.5', '27.5 inch', ''], ['29', '29 inch', '']] }
    ];
    function prog(all) { return '<div class="prog" aria-hidden="true">' + Q.map(function (_, i) { return '<i class="' + (all || i <= st.step ? 'on' : '') + '"></i>'; }).join('') + '</div>'; }
    function pick() {
      var d = st.drop === 'unsure' ? null : st.drop;
      var want = { cheap: '1500w-motor-kit', trail: '2000w-motor-kit', fast: '5000w-motor-kit', max: '10-000w-motor-kit' }[st.use];
      var kit = want, note = '';
      var fits = function (h) { return KITS[h] && KITS[h].drops.indexOf(d) > -1; };
      if (d && KITS[kit] && !fits(kit)) {
        if (d === '135') { kit = '3000w-motor-kit'; note = 'The ' + KITS[want].short + ' kit needs 150 or 170 mm dropouts. On 135 mm, the 3,000 W is the most powerful kit that fits.'; }
        else if (d === '170') { kit = '5000w-motor-kit'; note = 'On 170 mm dropouts, the 5,000 W is the smallest kit that fits.'; }
      }
      if (!KITS[kit]) kit = Object.keys(KITS)[0];
      if (!d) note = KITS[kit].drops[0] === '150' ? 'This kit needs 150 or 170 mm dropouts. Measure before you order, or send us a photo.' : 'This kit fits 135 or 150 mm dropouts, which covers most mountain bikes. Measure before you order.';
      return { h: kit, note: note };
    }
    function chooseVariant(k) {
      var norm = function (s) { return String(s).replace(/[^0-9.]/g, ''); };
      var cands = k.variants.filter(function (v) { return v.available && v.options.some(function (o) { return norm(o) === st.wheel; }); });
      var score = function (v) { var s = 0; v.options.forEach(function (o) { if (/SW900/i.test(o)) s += 2; if (/^Sine/i.test(o)) s += 1; if (/Wide/i.test(o)) s += 4; if (/Black/i.test(o)) s += 1; }); return s; };
      cands.sort(function (a, b) { return score(b) - score(a); });
      return cands[0] || k.variants.find(function (v) { return v.available; });
    }
    function draw() {
      if (st.step < Q.length) {
        var q = Q[st.step];
        root.innerHTML = prog() + '<div class="fq"><p class="crumbs">Question ' + (st.step + 1) + ' of ' + Q.length + '</p><h1>' + esc(q.t) + '</h1><p class="lede">' + esc(q.d) + '</p>' +
          (q.measure ? '<div class="measure"><svg viewBox="0 0 200 90" fill="none" stroke="#1c1b1a" stroke-width="3"><path d="M30 10v70M170 10v70"/><path d="M38 45h124" stroke-dasharray="5 5"/><path d="M38 45l10-6M38 45l10 6M162 45l-10-6M162 45l-10 6"/><circle cx="30" cy="45" r="6" fill="#f5d812"/><circle cx="170" cy="45" r="6" fill="#f5d812"/></svg><span>Take the rear wheel out and measure straight across, inside face to inside face. 135 mm is the most common on older and cheaper mountain bikes.</span></div>' : '') +
          '<div class="opts">' + q.o.map(function (o) { return '<button type="button" class="optc" data-fz="' + esc(o[0]) + '"><span><b>' + esc(o[1]) + '</b>' + (o[2] ? '<span>' + esc(o[2]) + '</span>' : '') + '</span>' + ARROW + '</button>'; }).join('') + '</div>' +
          (st.step > 0 ? '<p class="fq-back"><button class="link" type="button" data-fzback>Back</button></p>' : '') + '</div>';
      } else {
        var r = pick(), k = KITS[r.h], v = chooseVariant(k), b = k.bundled ? null : k.battery;
        var total = (v ? v.price : 0) + (b ? b.price : 0);
        st.result = { v: v, b: b };
        var fitsLine = st.drop !== 'unsure' && k.drops.indexOf(st.drop) > -1 ? '<li>' + CHECK + '<span>Fits your ' + esc(st.drop) + ' mm dropouts</span></li>' : '';
        var pair = k.bundled
          ? '<div class="result-pair"><span class="mini"></span><span><b>Battery bundle available</b><span>Pick the 72 V 40 Ah option on the kit page to save about $50 on the matched battery.</span></span><span></span></div>'
          : (b ? '<div class="result-pair"><span class="mini">' + (b.img ? '<img src="' + esc(b.img) + '" alt="">' : '') + '</span><span><b>' + esc(b.name) + ' battery</b><span>' + esc(b.detail) + '. Our pick for the ' + esc(k.short) + ' kit. <a class="link" href="' + esc(k.url) + '">Other battery options</a></span></span><b class="num">' + formatMoney(b.price) + '</b></div>' : '');
        root.innerHTML = prog(true) + '<p class="crumbs">Your match</p><div class="result"><div class="result-top"><div class="art">' + (k.img ? '<img src="' + esc(k.img) + '" alt="' + esc(k.title) + '">' : '') + '</div><div><h2>' + esc(k.short) + ' kit</h2><p>' + esc(k.sub) + '</p><ul class="result-why"><li>' + CHECK + '<span>' + esc(k.volts) + ', ' + esc(k.amps) + ' controller, up to ' + esc(k.speed) + '</span></li><li>' + CHECK + '<span>Laced into a ' + esc(st.wheel) + ' inch rim</span></li>' + fitsLine + '</ul>' + (r.note ? '<p class="need" style="margin-top:1rem">' + esc(r.note) + '</p>' : '') + '</div></div>' + pair +
          '<div class="result-foot"><span class="t">' + (b ? 'Kit + battery ' : 'Kit ') + '<b class="num">' + formatMoney(total) + '</b></span><span style="display:flex;gap:.6rem;flex-wrap:wrap"><a class="btn btn-line" href="' + esc(k.url) + (v ? '?variant=' + v.id : '') + '">See kit details</a>' + (v ? '<button class="btn btn-buy" type="button" data-fzadd>' + (b ? 'Add both to cart' : 'Add to cart') + '</button>' : '') + '</span></div><p class="form-msg" id="fzMsg" style="padding:0 1.5rem 1rem"></p></div><p class="fq-back"><button class="link" type="button" data-fzreset>Start again</button></p>';
      }
      if (!reduceMotion) { root.classList.remove('swap'); void root.offsetWidth; root.classList.add('swap'); }
    }
    root.addEventListener('click', function (e) {
      var o = e.target.closest('[data-fz]');
      if (o) { st[Q[st.step].k] = o.dataset.fz; st.step++; draw(); var h = $('h1,h2', root); if (h) { h.setAttribute('tabindex', '-1'); h.focus(); } return; }
      if (e.target.closest('[data-fzback]')) { st.step--; draw(); return; }
      if (e.target.closest('[data-fzreset]')) { st = { step: 0 }; draw(); return; }
      if (e.target.closest('[data-fzadd]')) {
        var items = [{ id: st.result.v.id, quantity: 1 }]; if (st.result.b) items.push({ id: st.result.b.id, quantity: 1 });
        addItems(items).catch(function (err) { var m = $('#fzMsg'); if (m) m.textContent = (err && err.description) || 'Couldn\'t add to cart. Try again.'; });
      }
    });
    draw();
  }
})();
